import React from 'react';
import { parseEntities } from '../../utils/helpers';

const CardSeries = ({ title, intro, permalink, main_genre, tags, poster_desktop, poster_mobile, poster_series }) => {
	const mainGenreFormatted = main_genre && Object.values(main_genre)[0];
	return (
		<li className="tile-series music-card">
			<div className={`tile-series__img-container music-card__image-wrapper`}>
				<img src={poster_series} alt={title} className={`music-card__image tile-series__img`} />

				<div className="music-card__title-wrapper">
					<a className={`tile-series__link`} href={permalink}>
						<h3 className="heading-s tile-series__title">{parseEntities(title)}</h3>
					</a>
				</div>
			</div>
			<div className={`tile-series__information`}>
				<div className="tile-series__content music-card__content music-card__content--no-button">
					{(mainGenreFormatted && mainGenreFormatted.trim() !== '' && mainGenreFormatted !== 'Leeg') || (tags && Object.keys(tags).length > 0) ? (
						<ul className="label-list">
							{mainGenreFormatted && mainGenreFormatted.trim() !== '' && mainGenreFormatted !== 'Leeg' && (
								<li className="agenda-item__tag" key="extra-item">
									<span className="label-item">{mainGenreFormatted}</span>
								</li>
							)}
							{tags &&
								Object.keys(tags).map((tag, index) => {
									return (
										<li className="agenda-item__tag" key={index} data-value={tags[tag]}>
											<span className="label-item">{parseEntities(tags[tag])}</span>
										</li>
									);
								})}
						</ul>
					) : null}
					{intro && <p className="music-card__description music-card__description--purple music-card__flexible">{intro}</p>}
				</div>
			</div>
		</li>
	);
};

export default CardSeries;
